import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String,
  }
  declare urlValue: string

  visit(event: Event): void {
    event.preventDefault()
    event.stopPropagation()

    window.open(this.urlValue)
  }
}
